//@flow
import BaseEntitySelectors from 'common/redux/selectors/BaseEntitySelectors';
import { createSelector } from 'reselect';

import { clientSelector } from 'common/redux/selectors/queryParamsSelectors';

class ContractSelectors extends BaseEntitySelectors {
    constructor() {
        super('contract');
    }

    getIsEntityVersionsLoading = createSelector(
        [this.storeSelector, clientSelector, (_, props) => props.contractId],
        (entityState, clientId, contractId) => {
            return entityState.getIn([
                'records',
                clientId,
                'entities',
                'versions',
                contractId,
                'status',
                'isLoading'
            ]);
        }
    );

    getEntityVersions = createSelector(
        [this.storeSelector, clientSelector, (_, props) => props.contractId],
        (entityState, clientId, contractId) => {
            return entityState.getIn([
                'records',
                clientId,
                'entities',
                'versions',
                contractId,
                'records'
            ]);
        }
    );
}

export default new ContractSelectors();
